import { playCFVideos } from './body.js';
var lazyLoadTarget;
var lazy_in_progress = false;
var lazy_last_loaded_page = 2;
var lazy_total_num_pages = 0;
var lazy_additional_params = null;
var lazy_URL = null;
var lazy_list_item_target = null;
var lazy_list_target = null;
var lazy_current_URL;

function lazy_load(url, total_num_pages, additional_params, list_item_target, list_target) {
    // Hide pagination if JS is enabled, else fallback to normal pagination method
    lazy_additional_params = typeof additional_params !== 'undefined' ? additional_params : null;
    lazy_total_num_pages = total_num_pages;
    lazy_URL = typeof url !== 'undefined' ? url : null;
    lazy_list_item_target = typeof list_item_target !== 'undefined' ? list_item_target : null;
    lazy_list_target = typeof list_target !== 'undefined' ? list_target : null;
    $('.pagination').remove();
}

console.log('lazyload.js loaded');

export { lazy_load };

window.playCFVideos = playCFVideos;

jQuery(function($){
    $(window).scroll(function(){
        if (lazy_total_num_pages > 1 && lazy_URL) {
            var bottom_of_page = false;
    
            var scrollTopPos = $(document).scrollTop();
            var colophonPos = lazy_list_target.children(':last-child').position().top;
    
            var offset = -500;
    
            if ((scrollTopPos + $(window).outerHeight()) >= (colophonPos + offset)) {
                bottom_of_page = true;
            }
    
            if(bottom_of_page && lazy_last_loaded_page <= lazy_total_num_pages) {
                if(lazy_in_progress) {
                    return;
                }
                $('.lazy_load').before('<div class="lazy-loading"><div></div><div></div><div></div><div></div></div>');
                lazy_in_progress = true;
    
                lazy_current_URL = lazy_URL + '/page/' + lazy_last_loaded_page + '?' + (lazy_additional_params !== null ? lazy_additional_params.replace(/&amp;/g, '&') : '');
    
                console.log(lazy_current_URL);
    
                $.ajax({
                    url: lazy_current_URL,
                    dataType: 'html',
                    success: function(html) {
                        var div = $(lazy_list_item_target, $(html)).addClass('done');
                        lazy_list_target.append(div).find($(div)).hide().fadeIn();
                        $('.lazy-loading').remove();
                        lazy_last_loaded_page++;
                        lazy_in_progress = false;
                        playCFVideos();
                    }
                });
            }
        }
    });
});
